// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"articleFilteredList_is-mob__1z1M_","is-desk":"articleFilteredList_is-desk__31PO3","container__head":"articleFilteredList_container__head__MWM_Y"};